import { render, staticRenderFns } from "./GradePraise.vue?vue&type=template&id=74b8f0e1&scoped=true&"
import script from "./GradePraise.vue?vue&type=script&lang=js&"
export * from "./GradePraise.vue?vue&type=script&lang=js&"
import style0 from "./GradePraise.vue?vue&type=style&index=0&id=74b8f0e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8f0e1",
  null
  
)

export default component.exports